module.exports = __webpack_public_path__ + "static/media/GA-2100FF-8AER_OR03_sideview_right.6b053af4.jpg";